import { types } from '../../../constants/ActionTypes'

const initialState = {
  records: [],
  mount: false,
}

const eventCard = (state = initialState, action) => {
  switch (action.type) {
    case types.eventCard.MOUNT:
      return { ...state, mount: true }
    case types.eventCard.UNMOUNT:
      return { ...state, mount: false }
    case types.eventCard.REQUEST_SELECT:
      return state
    case types.eventCard.RESPONSE_SELECT:
      if (action.response.result === false || action.response.records.length !== 1) {
        return state
      }
      let records = state.records.filter(record => record.id !== action.response.records[0].id)
      records.push(action.response.records[0])
      return { ...state, records }
    default:
      return state
  }
}

export default eventCard


// WEBPACK FOOTER //
// ./src/reducers/Common/Event/EventCard.js